import { Component, ElementRef, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { Common } from 'src/app/common/common';
import { ActivatedRoute, Router } from '@angular/router';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';
import { IDonorInformation, IDonorContact, IAwardCountry } from 'src/app/interface/IDonorContact';
import { CompositeFilterDescriptor, process, State, filterBy } from '@progress/kendo-data-query';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { FormCanDeactivate } from 'src/app/form-can-deactivate/form-can-deactivate.component';
import { AwardInfoService } from 'src/app/service/award-information/award-info.service';
import { CommonService } from 'src/app/service/common/common.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-donor-information-entry',
  templateUrl: './donor-information-entry.component.html',
  styleUrls: ['./donor-information-entry.component.scss']
})

export class DonorInformationEntryComponent extends FormCanDeactivate implements OnInit {

  constructor(public anchor: ElementRef<any>, private dialogService: DialogService, private commonService: CommonService,
              private router: Router, private awardInfoService: AwardInfoService, private notificationService: NotificationService,
              private activatedRoute: ActivatedRoute, private formBuilder?: FormBuilder) {
              super();
            }

  @ViewChild('ngFormDirtyCheck') ngFormDirtyCheck: NgForm; // for dirty check

  public donorEntryForm: FormGroup;
  public contactEntryForm: FormGroup;
  public defaultGuid: string = '00000000-0000-0000-0000-000000000000';
  public donorId: string;
  public pageTitle: string = '';
  public donorAgencyList: IKeyPairValue[] = [];
  public donorAgencyOriginalList: IKeyPairValue[] = [];
  public selectedCountryItem: IAwardCountry[] = [];
  public countryOriginalList: IAwardCountry[] = [];
  public isDonorAgencyNameValid: boolean = false;
  public isAddressValid: boolean = false;
  public isCityValid: boolean = false;
  public isFormValid: boolean = false;
  public dialogRef: DialogRef = new DialogRef();
  public isDonorNameReadOnly: boolean = false;
  public donorInformation: IDonorInformation = {};
  public awardAndContactList: IDonorInformation[] = [];
  public awardContactListGrid: GridDataResult;
  public newDonorcontactInformation: IDonorContact[] = [];
  private counter: number = this.newDonorcontactInformation.length;
  public contactItems: IDonorContact[] = [];
  public donorHeader: IDonorInformation = {};
  private editedRowIndex: number;
  public deleteContactIds: any[] = [];
  public componentName: string;
  public isDirtyCheck: string;
  public isSaveDonorFlag: boolean = false;
  // Pagination
  public contactListGrid: GridDataResult;
  public pageSize = 10;
  public skip = 0;
  public typedg: 'numeric' | 'input' = 'numeric';
  public buttonCount = 5;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public text: string = '';
  public enteredSearchText: string = '';
  public reqstate: State = {
    skip: 0,
    take: 10
  };
  public selectedCountry: string = '';
  public filter?: CompositeFilterDescriptor;
  public filteredData: any = [];
  // page level props.
  public donorAgencyName: string;
  public address1: string;
  public address2: string;
  public address3: string;
  public city: string;
  public state: string;
  public zipCode: string;
  public url: string;
  public countryId: number;
  public countryName: string;
  public isActive: boolean;
  public awards: string;
  public donorContactId: string;
  public contactId: string;
  public contactName: string;
  public contactTitle: string;
  public contactEmail: string;
  public contactNote: string;
  public tempList: IDonorContact = {};
  public inValidName: boolean = false;
  public inValidTitle: boolean = false;
  public inValidEmail: boolean = false;
  public inValidEmailFormat: boolean = false;
  public validContactSave: boolean = false;
  public saveFlag: boolean = false;
  public agreementId: string;


  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    const filterData = filterBy(this.awardAndContactList, filter);
    this.awardContactListGrid = process(filterData, this.reqstate);
  }

  dataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    if (this.filteredData.length > 0) {
      this.awardContactListGrid = process(this.filteredData, this.reqstate);
    } else {
      this.awardContactListGrid = process(this.awardAndContactList, this.reqstate);
    }
  }

  ngOnInit(): void {
    this.componentName = 'donorEntryComponent';
    this.initializeFormControls();
    this.initializeContactFormControls();
    this.getQueryParams();
    this.loadAPIValues();
    if (this.donorId) {
      this.getDonorInformation();
      this.getAwardContacts();
    }
  }

  // Initialize Form Controls
  initializeFormControls() {
    this.donorEntryForm = this.formBuilder.group({
      donorAgency: new FormControl(''),
      address1: new FormControl(null),
      address2: new FormControl(null),
      address3: new FormControl(null),
      city: new FormControl(''),
      state: new FormControl(null),
      zipcode: new FormControl(null),
      country: new FormControl(null),
      url: new FormControl(null),
      active: new FormControl(null),
      isActive: new FormControl(null),
      dialogDocumentType: new FormControl(null)
    });
  }

  // initialize Contact Form Controls
  initializeContactFormControls() {
    this.contactEntryForm = this.formBuilder.group({
      contactName: new FormControl(''),
      contactTitle: new FormControl(''),
      contactEmail: new FormControl(''),
      contactNotes: new FormControl(''),
    });
  }

  // get Query param
  public getQueryParams(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.id) {
        this.donorId = params.id;
      }
    });
  }

  // load API values
  loadAPIValues() {
    forkJoin([
      this.commonService.getCountry(),
      this.commonService.getDonorAgency(),
    ]).subscribe(([resp1, resp2]) => {
      this.countryOriginalList = resp1;
      this.selectedCountryItem = this.countryOriginalList.slice();
      this.donorAgencyOriginalList = resp2;
      this.donorAgencyList = this.donorAgencyOriginalList.slice();
    });
  }

  // Get Donor Information from API
  public getDonorInformation() {
    this.awardInfoService.getDonorInformation(this.donorId).subscribe(
      (response) => {
        this.donorInformation = response.Detail[0];
        this.pageTitle = this.donorInformation.donorAgencyName;
        this.donorId = this.donorInformation.id ? this.donorInformation.id : this.defaultGuid;
        this.donorEntryForm.patchValue({ donorAgency: this.donorId });
        this.donorEntryForm.patchValue({ address1: this.donorInformation.address1 });
        this.donorEntryForm.patchValue({ address2: this.donorInformation.address2 });
        this.donorEntryForm.patchValue({ address3: this.donorInformation.address3 });
        this.donorEntryForm.patchValue({ city: this.donorInformation.city });
        this.donorEntryForm.patchValue({ state: this.donorInformation.state });
        this.donorEntryForm.patchValue({ zipcode: this.donorInformation.zipCode });
        this.donorEntryForm.patchValue({ country: this.donorInformation.countryId });
        this.donorEntryForm.patchValue({ url: this.donorInformation.url });
        this.donorEntryForm.patchValue({ awards: this.donorInformation.awards });
        this.isActive = this.donorInformation.isActive;
      });
  }

  // To Get award contacts from API
  public getAwardContacts() {
    this.awardInfoService.getAwardContacts(this.donorId).subscribe((response) => {
      this.awardAndContactList = response;
      this.awardContactListGrid = {
        data: this.awardAndContactList.slice(this.skip, this.skip + this.pageSize),
        total: this.awardAndContactList.length
      };
    });
  }

  saveDonorForm(value: string) {
    this.isDirtyCheck = value;
    if (this.validateDonorInformation()) {
      this.setDonorInformation();
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Please fill all mandatory fields',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  // Set Award Information Header
  public setDonorInformation() {
    Common.loader('show');
    this.donorHeader.id = this.donorId ? this.donorId : this.defaultGuid;
    this.donorHeader.donorAgencyName = this.donorEntryForm.controls.donorAgency.value;
    this.donorHeader.address1 = this.donorEntryForm.controls.address1.value;
    this.donorHeader.address2 = this.donorEntryForm.controls.address2.value;
    this.donorHeader.address3 = this.donorEntryForm.controls.address3.value;
    this.donorHeader.city = this.donorEntryForm.controls.city.value;
    this.donorHeader.state = this.donorEntryForm.controls.state.value;
    this.donorHeader.zipCode = this.donorEntryForm.controls.zipcode.value;
    this.donorHeader.zip = this.donorEntryForm.controls.zipcode.value;
    this.countryId = this.donorEntryForm.controls.country.value;
    this.donorHeader.countryId = this.countryId;
    this.donorHeader.url = this.donorEntryForm.controls.url.value;
    if (this.donorEntryForm.controls.isActive.value === 'Yes') {
      this.isActive = true;
    } else if (this.donorEntryForm.controls.isActive.value === 'No') {
      this.isActive = false;
    }
    this.donorHeader.isActive = this.isActive;
    this.saveDonorInformation();
  }

  public saveDonorInformation() {
    this.awardInfoService.postDonorInformation(JSON.stringify(this.donorHeader)).subscribe((response: any) => {
      if (response) {
        this.show();
        this.donorId = response;
      }
    });
  }

  public saveDonorContacts() {
    Common.loader('show');
    if (this.donorId) {
      if (this.awardAndContactList.length > 0) {
        this.newDonorcontactInformation.forEach((element: any) => {
          if (!element.contactId) {
            element.contactId = this.defaultGuid;
            element.donorId = this.donorId;
          }
        });
        this.awardInfoService.postSaveAgreementDonorContact(JSON.stringify(this.newDonorcontactInformation)).subscribe((response: any) => {
          if (response) {
          this.show();
          }
        });
      }
    }
    this.deleteContactAPI();
    Common.loader('hide');
  }

  // To delete the Contact
  deleteContactAPI() {
    if (this.deleteContactIds.length > 0) {
      this.awardInfoService.deleteDonorInfoEntryContacts(JSON.stringify(this.deleteContactIds)).subscribe((response: any) => {
        if (response) {
          Common.loader('show');
          this.notificationService.show({
            content: 'Contact has been deleted.',
            position: { horizontal: 'center', vertical: 'bottom' },
            animation: { type: 'fade', duration: 800 },
            type: { style: 'success', icon: true },
            hideAfter: 5000,
          });
          this.routeAfterSave();
        }
      });
    }
  }

  public show() {
    Common.loader('show');
    this.notificationService.show({
      content: 'This has been saved.',
      position: { horizontal: 'center', vertical: 'bottom' },
      animation: { type: 'fade', duration: 800 },
      type: { style: 'success', icon: true },
      hideAfter: 5000,
    });
    this.routeAfterSave();
  }

  public handleDonorAgency(value: any) {
    if (value.length >= 1) {
      this.donorAgencyList = this.donorAgencyOriginalList.filter((s) => s.agencyName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.donorAgencyList = this.donorAgencyOriginalList;
    }
  }

  public donorSelectionChange(event: any) {
    if (event) {
      this.donorId = event;
    }
  }

  public handleCountryAgency(value: any) {
    if (value.length >= 1) {
      this.selectedCountryItem = this.countryOriginalList.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.selectedCountryItem = this.countryOriginalList;
    }
  }

  public countrySelectionChange(event: any) {
    if (event) {
      this.countryId = event;
    }
  }

  // Validation for isEmpty
  isEmpty(paramValue: any): boolean {
    if (paramValue === null || paramValue === undefined || paramValue === '') {
      return true;
    } else {
      return false;
    }
  }

  public validateDonorInformation(): boolean {
    this.isDonorAgencyNameValid = true;
    this.isAddressValid = true;
    this.isCityValid = true;
    if (!(this.isEmpty(this.donorEntryForm.controls.donorAgency.value))) {
      this.isDonorAgencyNameValid = false;
    }
    if (!(this.isEmpty(this.donorEntryForm.controls.address1.value))) {
      this.isAddressValid = false;
    }
    if (!(this.isEmpty(this.donorEntryForm.controls.city.value))) {
      this.isCityValid = false;
    }
    this.isFormValid = !this.isDonorAgencyNameValid && !this.isAddressValid && !this.isCityValid;
    return this.isFormValid;
  }

  // To cancel donor information entry
  cancelDonorForm() {
    this.dialogRef = this.dialogService.open({
      title: 'PleaseConfirm',
      content: 'Are you sure you want to cancel this?',
      actions: [
        { text: 'Yes', primary: true },
        { text: 'No' }],
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs.text && rs.text === 'Yes') {
        this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/donor-list']));
      }
    });
  }

  routeAfterSave() {
    if (this.isDirtyCheck !== 'dirtyCheck') {
      this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(
        () => this.router.navigate(['/donor-information-entry'],
          { queryParams: { id: this.donorId } }));
    }
    Common.loader('hide');
  }

  resetValidation() {
    this.inValidName = false;
    this.inValidTitle = false;
    this.inValidEmail = false;
    this.inValidEmailFormat = false;
  }

  // ContactS Grid
  public addHandler({ sender }) {
    this.closeEditor(sender);
    this.resetValidation();
    this.initializeContactFormControls();
    sender.addRow(this.contactEntryForm);
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender);
    this.contactEntryForm = this.formBuilder.group({
      contactName: dataItem.name,
      contactTitle: dataItem.title,
      contactEmail: dataItem.email,
      contactNotes: dataItem.note,
    });
    this.resetValidation();
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.contactEntryForm);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public validateContact(formGroup): boolean {
    this.inValidName = true;
    this.inValidTitle = true;
    this.inValidEmail = true;
    if (!(this.isEmpty(formGroup.controls.contactName.value))) {
      this.inValidName = false;
    }
    if (!(this.isEmpty(formGroup.controls.contactTitle.value))) {
      this.inValidTitle = false;
    }
    if (!(this.isEmpty(formGroup.controls.contactEmail.value))) {
      this.inValidEmail = false;
      if (formGroup.controls.contactEmail.value) {
        if (this.commonService.isValidEmail(formGroup.controls.contactEmail.value)) {
          this.inValidEmailFormat = false;
        } else {
          this.inValidEmailFormat = true;
        }
      }
    }
    if (this.inValidName || this.inValidTitle || this.inValidEmail || this.inValidEmailFormat) {
      return this.validContactSave = false;
    } else {
      return this.validContactSave = true;
    }
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew, dataItem }, agreementId: any) {
    this.saveFlag = this.validateContact(formGroup);
    this.tempList = {};
    const tempData: IDonorContact = {};
    this.isSaveDonorFlag = false;
    if (this.saveFlag) {
      this.tempList.name = formGroup.controls.contactName.value;
      this.tempList.title = formGroup.controls.contactTitle.value;
      this.tempList.email = formGroup.controls.contactEmail.value;
      this.tempList.note = formGroup.controls.contactNotes.value;
      if (isNew) {
        if (agreementId) {
          this.awardAndContactList.forEach((element: any) => {
            if (agreementId === element.agreementId) {
              this.tempList.id = this.defaultGuid;
              this.tempList.agreementId = agreementId;
              this.tempList.donorContactId = this.defaultGuid;
              this.tempList.contactId = this.defaultGuid;
              tempData.id = this.defaultGuid;
              tempData.donorId = this.donorId;
              tempData.contactId = this.defaultGuid;
              tempData.name = this.tempList.name;
              tempData.title = this.tempList.title;
              tempData.email = this.tempList.email;
              tempData.note = this.tempList.note;
              tempData.rowId = this.counter++;
              this.tempList.rowId = tempData.rowId;
              this.tempList.donorContact = {};
              this.tempList.donorContact = tempData;
              if (element.contacts === null) {
                element.contacts = [];
                element.contacts.push(tempData);
              } else {
                element.contacts.push(tempData);
              }
              this.newDonorcontactInformation.push(this.tempList);
              this.saveDonorContacts();
            }
          });
        }
      } else {
        if (agreementId) {
          this.awardAndContactList.forEach((element: any) => {
            if (element.agreementId === agreementId) {
              element.contacts.forEach((ele: any) => {
                if (ele.contactId === dataItem.contactId) {
                  const obj: IDonorContact = {};
                  ele.name = formGroup.controls.contactName.value;
                  ele.title = formGroup.controls.contactTitle.value;
                  ele.email = formGroup.controls.contactEmail.value;
                  ele.note = formGroup.controls.contactNotes.value;
                  this.tempList.agreementId = agreementId;
                  this.tempList.donorContactId = dataItem.donorContactId;
                  this.tempList.contactId = dataItem.contactId;
                  obj.donorId = this.donorId;
                  this.tempList.id = dataItem.id;
                  obj.contactId = dataItem.contactId;
                  obj.name = this.tempList.name;
                  obj.title = this.tempList.title;
                  obj.email = this.tempList.email;
                  obj.note = this.tempList.note;
                  this.tempList.donorContact = {};
                  this.tempList.donorContact = obj;
                  this.newDonorcontactInformation.push(this.tempList);
                }
              });
            }
          });
        }
        this.awardContactListGrid = process(this.awardAndContactList, this.reqstate);
        this.saveDonorContacts();
      }
      sender.closeRow(rowIndex);
      const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
      element.click();
      this.contactEntryForm.reset();
    } else {
      let contentName = '';
      if (this.inValidName === true && this.inValidTitle === true && this.inValidEmail === true) {
        contentName = 'Please select Contact Name, Contact Title and Contact Email';
      } else if (this.inValidName === true && this.inValidTitle === false && this.inValidEmail === false ) {
        contentName = 'Please select Contact Name';
      } else if (this.inValidName === false && this.inValidTitle === true && this.inValidEmail === false ) {
        contentName = 'Please select Contact Title';
      } else if (this.inValidName === false && this.inValidTitle === false && this.inValidEmail === true ) {
        contentName = 'Please select Contact Email';
      } else if (this.inValidName === true && this.inValidTitle === true && this.inValidEmail === false ) {
        contentName = 'Please select Contact Name and Contact Title';
      } else if (this.inValidName === false && this.inValidTitle === true && this.inValidEmail === true ) {
        contentName = 'Please select Contact Title and Contact Email';
      } else if (this.inValidName === true && this.inValidTitle === false && this.inValidEmail === true ) {
        contentName = 'Please select Contact Name and Contact Email';
      } else if (this.inValidEmailFormat === true) {
        contentName = 'Invalid email format';
      }
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: contentName ,
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public removeHandler({ dataItem }, agreementId: string): void {
    Common.loader('show');
    this.deleteContactIds = [];
    if (dataItem.contactId !== this.defaultGuid) {
      const result = this.awardAndContactList.filter(awardAndContact => awardAndContact.agreementId === agreementId)
        .map(element => {
          const index = element.contacts.findIndex(contact => contact.contactId === dataItem.contactId);
          const deleteIds = element.contacts.filter(contact => contact.contactId === dataItem.contactId)[0];
          deleteIds.agreementId = agreementId;
          element.contacts.splice(index, 1);
          return deleteIds;
        });
      this.deleteContactIds.push(result[0]);
      this.awardContactListGrid = process(this.awardAndContactList, this.reqstate);
      this.deleteContactAPI();
    } else {
      const result = this.awardAndContactList.filter(awardAndContact => awardAndContact.agreementId === agreementId)
        .map(element => {
          const index = element.contacts.findIndex(contact => contact.rowId === dataItem.rowId);
          element.contacts.splice(index, 1);
          const deleteIndex = this.newDonorcontactInformation.findIndex(contact => contact.rowId === dataItem.rowId);
          this.newDonorcontactInformation.splice(deleteIndex, 1);
        });
    }
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    // this.contactEntryForm = undefined;
  }

}
